export * as plugins from './src/extensions/dashboard-pages-plugin-props.js';
